import React, { Component } from 'react';

class RunButton extends Component {

    constructor(props) 
    {
        super(props)

        this.state = {
            application: props.application,
            textAreaID: props.textAreaID,
        }

        this.actionClick = this.actionClick.bind(this)
    }

    actionClick(event){
        let manifestText = document.getElementById(this.state.textAreaID).value
        this.state.application.setNewManifest(manifestText)
        

    }

    render() {
        return (
            <button className="btn btn-sm btn-primary m-2 float-center" onClick={this.actionClick}>Manifest to App</button>
        )
    }
}

export default RunButton;